/**
 * Build-time stub for `jspdf`, aliased in vite.config.js.
 *
 * PDF export is intentionally disabled app-wide: `materialTableProps` in
 * src/utils/props.jsx sets `exportButton: { csv: true }` and additionally
 * strips the "Export as PDF" menu item from the DOM. material-table still
 * hard-requires jspdf in dist/components/m-table-toolbar.js:
 *
 *   var jsPDF = typeof window !== "undefined" ? require("jspdf").jsPDF : null;
 *   ...
 *   if (jsPDF !== null) { ...build the PDF... }
 *
 * Returning null for `jsPDF` takes the branch material-table already handles,
 * so its toolbar degrades exactly as designed. Aliasing here keeps jspdf and
 * its optional dependency tree (dompurify, canvg, html2canvas, core-js) out of
 * the bundle entirely.
 *
 * To re-enable PDF export: drop the aliases from vite.config.js, delete this
 * stub and src/stubs/jspdf-autotable.js, and enable `exportButton.pdf` in
 * src/utils/props.jsx.
 */
export const jsPDF = null;

export default { jsPDF };
